module.exports = __webpack_public_path__ + "static/media/phone-primary.e8e6eb6f.svg";